import httpService from "../services/httpService";

// Redeems an invite code stashed in sessionStorage by Join.js before the user
// authenticated (password login/register or Google SSO), then routes them
// straight to the club instead of the generic post-auth dashboard route.
export async function redeemPendingInvite(navigate) {
  const signup_token = sessionStorage.getItem('signup_token');
  if (!signup_token) return false;

  try {
    const res = await httpService.post('invite/redeem', { code: signup_token });
    const clubGuid = res.data?.data?.podcast_club?.guid;
    sessionStorage.removeItem('signup_token');
    sessionStorage.removeItem('signup_club');
    if (clubGuid) {
      navigate(`/listener-podcast-club/${clubGuid}`);
      return true;
    }
  } catch {
    // invalid/expired code — clear it so it isn't retried on every future login
    sessionStorage.removeItem('signup_token');
    sessionStorage.removeItem('signup_club');
  }
  return false;
}
